import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tabs-section" }
const _hoisted_2 = { class: "col-md-10 col-lg-9 col-xl-8" }
const _hoisted_3 = { class: "row-section" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "title col-md-4 col-sm-4" }, "Height", -1)
const _hoisted_5 = { class: "col-md-8 col-sm-8" }
const _hoisted_6 = { class: "row-section" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "title col-md-4 col-sm-4" }, "Depth", -1)
const _hoisted_8 = { class: "col-md-8 col-sm-8" }
const _hoisted_9 = { class: "row-section" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "title col-md-4 col-sm-4" }, "Width", -1)
const _hoisted_11 = { class: "col-md-8 col-sm-8" }
const _hoisted_12 = { class: "row-section" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "title col-md-4 col-sm-4" }, "Weight", -1)
const _hoisted_14 = { class: "col-md-8 col-sm-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_input = _resolveComponent("v-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_input, {
              modelValue: _ctx.store.height,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.store.height) = $event)),
              type: "number"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_v_input, {
              modelValue: _ctx.store.depth,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.store.depth) = $event)),
              type: "number"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_v_input, {
              modelValue: _ctx.store.width,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.store.width) = $event)),
              type: "number"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_v_input, {
              modelValue: _ctx.store.weight,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.store.weight) = $event)),
              type: "number"
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onChangeTab('prev'))),
        class: "tabs-actions btn btn-secondary"
      }, "Prev"),
      _createElementVNode("button", {
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onChangeTab('next'))),
        class: "tabs-actions btn btn-secondary"
      }, "Next")
    ])
  ]))
}